module.exports = "/assets/data/5044d273fd91c44f98d30f9e86f9a0e0-DE14.data.json";